/******************************************************************************
 * Created Date: Monday June 8th 2020                                         *
 * Author: Sean W.                                                            *
 * -----                                                                      *
 * Last Modified: Thu Apr 28 2022                                             *
 * Modified By: Sean W.                                                       *
 * -----                                                                      *
 * Copyright (c) 2020 MultiSensor                                             *
 ******************************************************************************/
import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useState } from "react";
const PREFIX = "SpinnerButton";

const classes = {
  btnroot: `${PREFIX}-btnroot`,
  btnwrapper: `${PREFIX}-btnwrapper`,
  buttonProgress: `${PREFIX}-buttonProgress`,
  btn: `${PREFIX}-btn`
};

const Root = styled("div")(({ theme }) => ({
  [`.${classes.btnroot}`]: {
    display: "inline",
    alignItems: "center",
    height: "100%",
    width: "100%"
  },

  [`.${classes.btnwrapper}`]: {
    // margin: theme.spacing(1),
    position: "relative",
    display: "inline-block",
    height: "100%",
    width: "100%"
  },

  [`.${classes.buttonProgress}`]: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },

  [`.${classes.btn}`]: {
    minWidth: 140,
    height: "100%",
    width: "100%",
    textTransform: "none",
    color: "#03C2C2",
    border: "1px solid #0B5151"
  }
}));

const SpinnerButton = props => {
  const [loading, setLoading] = useState(false);

  const performAction = () => {
    if (!props.onClick) return;
    let success, minTimeReached;

    setLoading(true);
    // minimum 1 second spinner
    setTimeout(() => {
      minTimeReached = true;

      if (success) setLoading(false);
    }, 1000);

    props
      .onClick()
      .then(() => {
        props.onSuccess();
      })
      .catch(() => {
        props.onError();
      })
      .finally(() => {
        success = true;
        if (minTimeReached) setLoading(false);
      });
  };

  return (
    <Root className={classes.btnroot}>
      <div className={classes.btnwrapper}>
        <Button
          className={classes.btn}
          // color={"secondary"}
          // variant="outlined"
          {...props}
          onClick={performAction}
          disabled={props.disabled || props.submitting || loading}
        >
          {props.children}
        </Button>
        {(props.submitting || loading) && (
          <CircularProgress
            role="spinner"
            size={24}
            className={classes.buttonProgress}
            color={props.color}
          />
        )}
      </div>
    </Root>
  );
};

SpinnerButton.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
};

SpinnerButton.defaultProps = {
  onSuccess: () => {},
  onClick: () => {},
  onError: () => {},
  text: "Submit",
  disabled: false
};

export default SpinnerButton;
